import { useLayoutEffect, useRef, useState } from "react"
import { gsap } from "gsap"
import "./video-scroll.component.css"
import { playIcon } from "../../icons"
import useCheckForMobileHook from "../../hooks/useCheckForMobileHook"
import VideoModalComponent from "../video-modal/video-modal.component"
import { toCdnUrl } from "../../utils/cdn.util"

const VideoScrollComponent = (props) => {
  const { id, Media, MediaShort, ExpandOnScroll } = props
  const [showModal, setShowModal] = useState(false)
  const videoElRef = useRef()
  const isMobile = useCheckForMobileHook()

  useLayoutEffect(() => {
    if (id && ExpandOnScroll && !isMobile) {
      console.log("create video scroll trigger")

      // Setup scroll trigger
      const tl = gsap
        .timeline({
          scrollTrigger: {
            trigger: `.dagger-video-${id}`,
            scrub: 2,
            start: "-50% top",
            end: "+=30%",
          },
        })
        .from(".dagger-video-scroll-video", {
          scale: 0.75,
          ease: "none",
        })

      return () => {
        tl.scrollTrigger?.kill()
        tl.kill()
      }
    }
  }, [id, ExpandOnScroll, isMobile])

  if (!Media) {
    return null
  }

  const handleShowVideo = () => {
    // Pause current
    videoElRef.current.pause()

    // Open full
    setShowModal({
      id,
      src: toCdnUrl(Media.data.attributes.url),
      UseLandscapeAspectRatio: true,
    })
  }

  const handleCloseVideo = () => {
    // Close full
    setShowModal(false)

    // Resume current
    videoElRef.current.play()
  }

  return (
    <div className={`dagger-video-scroll dagger-video-${id}`}>
      {showModal && (
        <VideoModalComponent {...showModal} onClose={handleCloseVideo} />
      )}
      {/* <h1>{Heading}</h1> */}
      <svg width="0" height="0" className="dagger-video-filter">
        <filter id="duotone" colorInterpolationFilters="sRGB">
          <feColorMatrix
            type="matrix"
            values="0.299 0.587 0.114 0 0
                                         0.299 0.587 0.114 0 0
                                         0.299 0.587 0.114 0 0
                                         0     0     0     1 0"
          />
          <feComponentTransfer>
            <feFuncR type="table" tableValues="0.125 0.286 0.847" />
            <feFuncG type="table" tableValues="0.043 0.267 1.000" />
            <feFuncB type="table" tableValues="0.212 0.310 0.420" />
          </feComponentTransfer>
        </filter>
      </svg>
      <div className="dagger-video-scroll-video">
        <video
          ref={videoElRef}
          playsInline
          src={toCdnUrl(MediaShort.data.attributes.url)}
          autoPlay
          muted
          loop
          onClick={handleShowVideo}
        ></video>
        <div className="grain" />
        <div className="video-play-icon">{playIcon}</div>
      </div>
    </div>
  )
}

export default VideoScrollComponent
